module.exports = __webpack_public_path__ + "img/2.01.thmb.7ca396aa.jpg";